import { Button, PageContainer } from "@shapr3d/frontend-lib";

import useTranslation from "../../hooks/useTranslation";
import { getShaprURLProtocol } from "../../urlUtils";
import Heading from "../Heading/Heading";

import style from "./InstantTrialSuccess.module.css";

const InstantTrialSuccess = () => {
  const { t, m } = useTranslation();
  return (
    <PageContainer>
      <div className={style.instantTrial}>
        <div className={style.instantTrialForm}>
          <Heading type="h1">{t(m.InstantTrialSuccess.ThankYou)}</Heading>
          <div className={style.text}>{t(m.InstantTrialSuccess.TrialActivated)}</div>
          <Button
            onClick={() => {
              window.location.replace(`${getShaprURLProtocol()}://`);
            }}
          >
            {t(m.InstantTrialSuccess.LaunchShapr3D)}
          </Button>
        </div>
      </div>
    </PageContainer>
  );
};

export default InstantTrialSuccess;
